import type { Flights } from "@b2bportal/air-shopping-api";
import { FlightSearchActions } from "@b2bportal/core-flights";
import {
  type FlightShopRequest,
  PackageEndpointsV2,
  type BundledPackageStateToFareId,
  type PackagesCustomizeFlightsShopResponse,
  type Requisition,
} from "@b2bportal/core-packages";
import { getDeviceType } from "@b2bportal/core-utilities";
import { axiosInstance } from "@hopper-b2b/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FlightShopActions } from "../../../flights/shop/store/slice";
import { PackagesBaseActions } from "../../slice/packages";
import type { PackagesSearch } from "../../types/packagesSearch";
import { createFlightSearch } from "@/pages/Packages/hooks";
export type FetchPackageFlightsRequisitionFulfillResponse = {
  flights: Flights;
  packageStateByFareId: BundledPackageStateToFareId;
};

export interface PackageFlightsRequisitionProps {
  search?: FlightShopRequest;
  packageToken: string;
}

export const fetchPackageFlightsRequisition = createAsyncThunk<
  FetchPackageFlightsRequisitionFulfillResponse,
  { search: PackagesSearch; requisition: Requisition },
  { rejectValue: { error: string } }
>(
  "packages/fetchFlightsRequisition",
  async ({ search, requisition }, thunkAPI) => {
    const { isDesktopAndUp } = getDeviceType();

    try {
      // set flight search
      const flightSearch = createFlightSearch(search);

      thunkAPI.dispatch(FlightSearchActions.setFlightSearch(flightSearch));

      thunkAPI.dispatch(FlightShopActions.setFetchFlightsPending());

      const {
        data: initialResponse,
      }: { data: PackagesCustomizeFlightsShopResponse } =
        await axiosInstance.post(PackageEndpointsV2.Requisition, {
          requisition: requisition,
        });

      // set initial package state
      const initialPackageState =
        initialResponse.flightShop.packageStateByFareId[
          initialResponse.flightShop.payload.summarizeResponse.flights
            .fares?.[0]?.id
        ] ?? undefined;

      if (initialPackageState) {
        thunkAPI.dispatch(
          PackagesBaseActions.setCurrentActivePackage(initialPackageState)
        );
      }

      // Map to flight store
      thunkAPI.dispatch(
        FlightShopActions.setFetchFlightsSuccess({
          flights: initialResponse.flightShop.payload.summarizeResponse.flights,
          prediction: undefined,
          trackingProperties: {},
        })
      );

      return {
        flights: initialResponse.flightShop.payload.summarizeResponse.flights,
        packageStateByFareId: initialResponse.flightShop.packageStateByFareId,
      };
    } catch (error) {
      // Reject the thunk with an error message
      thunkAPI.dispatch(FlightShopActions.setFetchFlightsRejected());

      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return thunkAPI.rejectWithValue({ error: errorMessage });
    }
  }
);
